/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_No_AudioInputs */

const en_playbar_no_audio = /** @type {(inputs: Playbar_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audio loaded`)
};

const es_playbar_no_audio = /** @type {(inputs: Playbar_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay audio cargado`)
};

/**
* | output |
* | --- |
* | "No audio loaded" |
*
* @param {Playbar_No_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_no_audio = /** @type {((inputs?: Playbar_No_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_No_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_no_audio(inputs)
	return en_playbar_no_audio(inputs)
});